// [init]

import moment from 'moment';
import Axios from 'axios'
import _ from 'lodash'


export default {


  namespaced: true,

  state: {
    // Listing of all jobs ( Array )
    jobsList: [],

    // Current Job being manipulated ( viewed or edited ) ( Object )
    status: '',
    activeJob: {},
    activeLastChecklists: {},
    currentChecklist: {},
    listBooking: {},
  },

  mutations: {

    // Update jobList with new list
    // @params: Array
    updateJobList( state, newList ) {
      state.jobsList = newList.map(item => {
        item.amountToPay = item.amountToPay / 100;
        return item;
      });
    },

    // Add a job into jobList
    addJob( state, newJob ) {
      state.jobsList.push( newJob );
    },

    // Delete a job from jobzList
    // @params: identifier (String)
    deleteJob( state, identifier ) {
      state.jobsList = state.jobsList.filter( job => {
        return job.id != identifier;
      } );
    },

    // Update the current active Job object
    // @params: newActiveJob (Object)
    updateActiveJob( state, newActiveJob ) {
      state.activeJob = newActiveJob;
    },

    updateActiveLastChecklists( state, newActiveLastChecklists ) {
      state.activeLastChecklists = newActiveLastChecklists;
    },

    updateCurrentChecklist( state, newCurrentChecklist ) {
      state.currentChecklist = newCurrentChecklist;
    },

    // Change status of jobForm
    // @params: newStatus (String)
    updateStatus( state, newStatus ) {
      state.status = newStatus;
    },

    resetState( state ) {
      state.status = '';
      state.activeJob = {};
      state.activeLastChecklists = {};
      state.currentChecklist = {};
    },
    resetStateJobList(state) {
      state.jobsList = [];
      console.log('destroy store JobList');
    },
    updateListBooking( state, data ) {
      state.listBooking = data;
    },
    updateCustomerData( state, data ) {
      state.listBooking.customer = data;
    },
  },

  actions: {
    
    /* 
    *  /GET jobs API
    *  Get all jobs from the server
    *  @return: Array
    */
    getJobs( { commit, state }, identifier ) {
      commit( 'resetStateJobList');
      return new Promise (( resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/jobs',
          params: {
            trash: this.state.auth.type == 'admin' ? '*' : '0',
            from: 0,
            size: 9999999,
            customerID: identifier
          },
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          commit( 'updateJobList', response.data );
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    /* 
    *  /GET/:id jobs API
    *  Get a single job from the server
    *  @params: Array (due to vuex limitations)
    *  [0]: identifier (String)
    *  [1]: action (String: view/edit)
    *  @return: Object
    */
    getSingleJob( { commit, state }, params ) {

      const identifier = params[0];
      const action = params[1];

      return new Promise ( (resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/jobs/' + identifier,
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          response.data.amountToPay = response.data.amountToPay / 100;
          commit( 'updateActiveJob', response.data );
          commit( 'updateStatus', action );
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    /* 
    *  /GET/:id jobs API
    *  Get a single job from the server
    *  @params: identifier (String)
    *  @return: Object
    */
    getJobsSingleCleaner( { commit, state }, identifier ) {

      return new Promise ( (resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/jobs',
          params: {
            cleanerID: identifier,
            sortby: 'startTime',
            order: 'desc',
            status: 'paid',
            size: 9999999
          },
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          response.data.amountToPay = response.data.amountToPay / 100;
          commit( 'updateJobList', response.data );
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    /* 
    *  /GET/:id jobs API
    *  Get a single job from the server
    *  @params: identifier (String)
    *  @return: Object
    */
    getJobsSingleCustomer( { commit, state }, identifier ) {

      return new Promise ( (resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/jobs',
          params: {
            customerID: identifier,
            size: 99999
          },
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          response.data.amountToPay = response.data.amountToPay / 100;
          commit( 'updateJobList', response.data );
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    /* 
    *  /POST jobs API
    *  Add a new job to the server
    *  @params: Object (jobs data)
    *  @return: Object
    */
    addJob( { commit, state }, [data, type] ) {
      console.log(type)
      
      return new Promise ( (resolve, reject ) => {
        let jobsUrl = '/jobs';
        if(type === 1) {
          jobsUrl = '/customers/createjob?XDEBUG_SESSION_START=1';
        }
        const postData = {
          label: data.label,
          packageID: data.packageID,
          numCleaners: data.numCleaners,
          cleaner1ID: data.cleaner1ID,
          cleaner2ID: data.cleaner2ID,
          cleaner3ID: data.cleaner3ID,
          cleaner4ID: data.cleaner4ID,
          cleaner5ID: data.cleaner5ID,
          customerID: data.customerID,
          addressID: data.addressID,
          startTime: data.startTime.format("YYYY-MM-DD HH:mm:ss"),
          endTime: data.endTime.format("YYYY-MM-DD HH:mm:ss"),
          status: data.status,
          paid: data.paid,
          requireCleaningSupplies: data.requireCleaningSupplies,
          specialRequests: data.specialRequests,
          creditsUsed: data.creditsUsed,
          amountToPay: data.amountToPay * 100,
          jobType: data.jobType,
          checklist: data.checklist,
          contactDetails: data.contactDetails,
          hasChangedDate: data.hasChangedDate,
          job_address_addressLine1: data.job_address_addressLine1,
          job_address_addressLine2: data.job_address_addressLine2,
          job_address_addressLine3: data.job_address_addressLine3,
          job_address_postal: data.job_address_postal,
          job_address_type: data.job_address_type,
          job_address_country: data.job_address_country,
          job_address_latitude: data.job_address_latitude,
          job_address_longitude: data.job_address_longitude,
          job_address_genderPreference: data.job_address_genderPreference,
          job_address_hasPets: data.job_address_hasPets,
          job_address_languagePreference: data.job_address_languagePreference,
          job_address_areaID: data.job_address_areaID,
          job_customer_email: data.job_customer_email,
          type_cleaner: data.searchCleaners
        };
        global.axios.request({
          method: 'post',
          // url: '/jobs',
          url: jobsUrl,
          validateStatus: ( status ) => { return status == 201; },
          data: postData
        })
        .then(response => {
          console.log(response)
          commit( 'addJob', response.data );
          const jobId = _.get(response,'data.id')
          const needUpdateCredit = data.needUpdateCredit;
          if(!_.isNil(jobId) && needUpdateCredit != true) {
            Axios.post('calendar/create_event', { jobId: jobId})
              .then(jobResponse => {
                console.log(jobResponse)
                resolve(response)
              })
              .catch(e => {
                console.log(e)
                resolve(response)
              })
          } else {
            resolve(response);
          }
          resolve(response);
        })
        .catch(error => {
          console.log(error.response.data);
          reject( error );
        });
      });


    },

    /* 
    *  /POST/:id jobs API
    *  Edits an existing job into the server
    *  @params: Object (jobs data)
    *  @return: Object
    */
    editJob( { commit, state }, data ) {

      return new Promise ((resolve, reject ) => {

        const postData = {
          label: data.label,
          packageID: data.packageID,
          numCleaners: data.numCleaners,
          cleaner1ID: data.cleaner1ID,
          cleaner2ID: data.cleaner2ID,
          cleaner3ID: data.cleaner3ID,
          cleaner4ID: data.cleaner4ID,
          cleaner5ID: data.cleaner5ID,
          customerID: data.customerID,
          addressID: data.addressID,
                    // startTime: data.startTime.format("YYYY-MM-DD HH:mm:ss"),
                    // endTime: data.endTime.format("YYYY-MM-DD HH:mm:ss"),
          startTime: data.startTime,
          endTime: data.endTime,
          status: data.status,
          paid: data.paid,
          requireCleaningSupplies: data.requireCleaningSupplies,
          specialRequests: data.specialRequests,
          review: data.review,
          reviewStarts: data.reviewStarts,
          creditsUsed: data.creditsUsed,
          amountToPay: data.amountToPay * 100,
          checklist: data.checklist,
          contactDetails: data.contactDetails,
          hasChangedDate: data.hasChangedDate,
                    job_address_addressLine1: data.job_address_addressLine1,
                    job_address_addressLine2: data.job_address_addressLine2,
                    job_address_addressLine3: data.job_address_addressLine3,
                    job_address_postal: data.job_address_postal,
                    job_address_type: data.job_address_type,
                    job_address_country: data.job_address_country,
                    job_address_latitude: data.job_address_latitude,
                    job_address_longitude: data.job_address_longitude,
                    job_address_genderPreference: data.job_address_genderPreference,
                    job_address_hasPets: data.job_address_hasPets,
                    job_address_languagePreference: data.job_address_languagePreference,
                    job_address_areaID: data.job_address_areaID,
                    job_customer_email: data.job_customer_email,
                    type_cleaner: data.searchCleaners,
                    send_email: data.send_email,
                    jobType: data.jobType,
                    type_cleaner: data.searchCleaners
        };

        global.axios.request({
          method: 'post',
          url: '/jobs/' + data.id + '/update',
          validateStatus: ( status ) => { return status == 200; },
          data: postData
        })
        .then(response => {
          commit( 'addJob', response.data );
                    const jobId = _.get(response,'data.id')
                    if(!_.isNil(jobId)) {
                        Axios
                            .post('calendar/create_event', {
                                jobId: jobId
                            })
                            .then(jobResponse => {
                                console.log(jobResponse)
                                resolve(response)
                            })
                            .catch(e => {
                                console.log(e)
                                resolve(response)
                            })

                    } else {
                        resolve(response);
                    }
        })
        .catch(error => reject( error ));

      });

    },
    createEvent({ commit, state }, jobId ){
      return new Promise ((resolve, reject ) => {
        const postData = {
          jobId: jobId,
        };
        global.axios.request({
          method: 'post',
          url: '/calendar/create_event',
          validateStatus: ( status ) => { return status == 200; },
          data: postData
        }).then(response => {
          console.log('created event');
          resolve(response);
        });
      });
    },

    editJobChecklist( { commit, state }, data ) {

      return new Promise ((resolve, reject) => {

        const postData = {
          checklist: data.checklist,
          date_added_checklist: data.add_checklist,
        };

        global.axios.request({
          method: 'post',
          url: '/jobs/' + data.id + '/update',
          validateStatus: ( status ) => { return status == 200; },
          data: postData
        })
        .then(response => {
          commit( 'addJob', response.data );
                    const jobId = _.get(response,'data.id')
                    if(!_.isNil(jobId)) {
                        Axios
                            .post('calendar/create_event', {
                                jobId: jobId
                            })
                            .then(jobResponse => {
                                console.log(jobResponse)
                                resolve(response)
                            })
                            .catch(e => {
                                console.log(e)
                                resolve(response)
                            })

                    } else {
                        resolve(response);
                    }
        })
        .catch(error => reject( error ));

      });

    },

    // get checklist job
    getJobChecklist( { commit, state }, params ) {

      const identifier = params[0];
      const action = params[1];

      return new Promise ( (resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/jobs/' + identifier,
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    // update job checklist
    updateJobChecklist( { commit, state }, data ) {

      return new Promise ((resolve, reject) => {

        const postData = {
          checklist: data.checklist,
          comment: data.ckComment,
          cleanerID: data.cleanerID
        };

        global.axios.request({
          method: 'post',
          url: '/job_checklists/' + data.id + '/update',
          validateStatus: ( status ) => { return status == 200; },
          data: postData
        })
        .then(response => {
            resolve(response);
        })
        .catch(error => reject( error ));

      });

    },

    // get pastChecklists
    getPastChecklists( { commit, state }, data ) {
      var identifier = data[0];
      return new Promise (( resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/job_checklists/' + identifier,
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          commit( 'updateActiveLastChecklists', response.data );
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    /* 
    *  /DELETE/:id jobs API
    *  Removes an existing job into the server
    *  @params: identifier (String)
    *  @return: 200 OK
    */
    deleteJob( { commit, state }, identifier ) {

      return new Promise ((resolve, reject ) => {

        global.axios.request({
          method: 'post',
          url: '/jobs/' + identifier + '/trash',
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          commit( 'deleteJob', identifier );
                    if(!_.isNil(identifier)) {
                        Axios
                            .post('calendar/delete_event', {
                                jobId: identifier
                            })
                            .then(jobResponse => {
                                console.log(jobResponse)
                                resolve(response)
                            })
                            .catch(e => {
                                console.log(e)
                                resolve(response)
                            })

                    } else {
                        resolve(response);
                    }
        })
        .catch(error => reject( error ));

      });

    },

    /* 
    *  /POST/:id/untrash jobs API
    *  Restores a job into the server from the trash
    *  @params: identifier (String)
    *  @return: 200 OK
    */
    untrashJob( { commit, state }, identifier ) {

      return new Promise ( (resolve, reject) => {

        global.axios.request({
          method: 'post',
          url: '/jobs/' + identifier + '/untrash',
          validateStatus: ( status ) => { return status == 200; },
        })
        .then(response => {
          const updatedList = state.jobsList.map(item => {
            if (item.id === identifier ) {
              let holder = item;
              holder.trash = 0;
              return holder;
            } else {
              return item;
            };
          });
          commit( 'updateJobList', updatedList );
        })
        .catch(error => reject( error ));

      });

    },

    cancelJob( { commit, state }, identifier ) {

      return new Promise ( (resolve, reject) => {

        global.axios.request({
          method: 'post',
          url: '/jobs/' + identifier + '/cancel',
          validateStatus: ( status ) => { return status == 200; },
        })
        .then(response => {
          commit( 'deleteJob', identifier );
                    if(!_.isNil(identifier)) {
                        Axios
                            .post('calendar/delete_event', {
                                jobId: identifier
                            })
                            .then(jobResponse => {
                                console.log(jobResponse)
                                resolve(response)
                            })
                            .catch(e => {
                                console.log(e)
                                resolve(response)
                            })

                    } else {
                        resolve(response);
                    }
        })
        .catch(error => reject( error ))

      });

    },
    ///
    updateCredit( { commit, state }, data ) {
      return new Promise ( (resolve, reject) => {
        const  postData = {
          credit_ID : data.credit,
          jobID: data.jobid,
          promocode: data.promocode
        }
        global.axios.request({
          method: 'post',
          url: '/customers/updatecredit?XDEBUG_SESSION_START=1',
          validateStatus: ( status ) => { return status == 200; },
          data : postData
        })
        .then(response => {
           if(!_.isNil(data.jobid)) {
               Axios
                 .post('calendar/create_event', {
                     jobId: data.jobid
                 })
                 .then(jobResponse => {
                     console.log(jobResponse)
                     resolve(response)
                 })
                 .catch(e => {
                     console.log(e)
                     resolve(response)
                 })
           } else {
               resolve(response);
           }
        })
      });
    },

    confirmJobAdmin( { commit, state }, data ) {
      return new Promise ( (resolve, reject) => {
        const  postData = {
          jobID: data.jobid,
          amountToPay: data.amountToPay,
          promocode: data.promocode
        }
        global.axios.request({
          method: 'post',
          url: '/customers/confirmJobAdmin',
          validateStatus: ( status ) => { return status == 200; },
          data : postData
        })
        .then(response => {
          if(!_.isNil(data.jobid)) {
            Axios
              .post('calendar/create_event', {
                jobId: data.jobid
              })
              .then(jobResponse => {
                 console.log(jobResponse)
                 resolve(response)
              })
              .catch(e => {
                 console.log(e)
                 resolve(response)
              })
          } else {
             resolve(response);
          }
        })
      });
    },

    /* 
    *  /GET jobs API CSV
    *  Get all jobs from the server as a CSV
    *  (different headers)
    *  @return: Array
    */
    getJobsCsv( { commit } ) {

      window.open( process.env.ENDPOINT + '/jobs/download_csv_file' );

    },

    reset( { commit, state } ) {
      commit( 'resetState' );
    },
    
    /* 
    *  /POST/:id jobs API
    *  add review for existing job
    *  @params: Object (jobs data)
    *  @return: Object
    */
    addReviewJob( { commit, state }, data ) {

      return new Promise ((resolve, reject ) => {

        const postData = {          
          review: data.review,
          reviewStarts: data.reviewStarts,          
        };

        global.axios.request({
          method: 'post',
          url: '/jobs/' + data.id + '/addreview',
          validateStatus: ( status ) => { return status == 200; },
          data: postData
        })
        .then(response => {                            
                    resolve(response);
        })
        .catch(error => reject( error ));

      });

    },  

    /*
    GET statictis of Jobs from Date to Date
    */
    getJobStatistics( { commit, state }, data ) {

      return new Promise ( (resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/jobs/statistics',
          params: {
            from_date: moment(data.fromDate).format('YYYY-MM-DD 00:00:00'),
            to_date: moment(data.toDate).format('YYYY-MM-DD 23:59:59'),
          },
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    /*
    GET statictis of promocode from Date to Date
    */
    getPromotionCodeStatistics( { commit, state }, data ) {

      return new Promise ( (resolve, reject ) => {

        global.axios.request({
          method: 'get',
          url: '/promocode/statistics',
          params: {
            from_date: moment(data.fromDate).format('YYYY-MM-DD 00:00:00'),
            to_date: moment(data.toDate).format('YYYY-MM-DD 23:59:59'),
          },
          validateStatus: ( status ) => { return status == 200; }
        })
        .then(response => {
          resolve( response );
        })
        .catch(error => reject( error ));

      });

    },

    updatePromocode( { commit, state }, data ) {
      return new Promise ( (resolve, reject) => {
        const postData = {
          promocode: data.promocode
        }
        global.axios.request({
          method: 'post',
          url: '/jobs/' + data.jobid + '/update-promocode',
          validateStatus: ( status ) => { return status == 200; },
          data : postData
        })
        .then(response => {
          resolve(response);
        })

      });

    },

    setListBooking( { commit, state }, data ) {
      return new Promise ( (resolve, reject) => {
        commit( 'updateListBooking', data );
        resolve(true);
      });
    },
    updateCustomerInfo( { commit, state }, data ) {
      commit( 'updateCustomerData', data );
    },

  }
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Jobs.js